import { Injectable } from '@angular/core';
import { TSearchResponseDTO } from '../../../points/point-search/point-search.consts';
import { TColumn } from '../../../site/site-table/columns/column.model';
import { getAllGroupedSortedColumns } from '../../../site/site-table/columns/get-all-grouped-sorted-columns';
import { GET_GROUPING } from '../../../site/site-table/columns/grouping.store';
import { ESortOrder } from '../../../site/site-table/sort-order-enum';
import { checkCustomWorkspaceId } from '../../../workspace/workspace';
import { EWorkspaces } from '../../../workspace/workspaces.enum';
import { EQuickSortKey, EQuickSortTranslatedKey } from './quick-sort.consts';

@Injectable({
  providedIn: 'root',
})
export class QuickSortService {
  getSortTransformed(): TSearchResponseDTO['sort'] {
    return this.transformColumns(getAllGroupedSortedColumns());
  }

  getGroupingSortTransformed(): TSearchResponseDTO['sort'] {
    const grouping = GET_GROUPING()
      .slice()
      .sort((a, b) => a.groupIndex - b.groupIndex)
      .map((column) => ({ ...column, sortOrder: column.groupOrder }));

    return this.transformColumns(grouping);
  }

  private transformColumns(sortedColumns: TColumn[]): TSearchResponseDTO['sort'] {
    const workspaceId = checkCustomWorkspaceId();
    const useAllCustomFieldIds =
      workspaceId === EWorkspaces.OVERVIEW || workspaceId === EWorkspaces.TIMELINE;

    const columns = sortedColumns.map((column) => ({
      keys:
        column?.customFieldIds && column?.customFieldIds?.length > 0
          ? useAllCustomFieldIds
            ? column.customFieldIds
            : [column.customFieldIds[0]]
          : [this.translateKey(column.name)],
      direction: column.sortOrder ?? ESortOrder.ASC,
    }));

    const lastIndexByKey = new Map<string, number>();
    columns.forEach((column, index) => {
      lastIndexByKey.set(column.keys.join(','), index);
    });

    return columns.filter(
      (column, index) => lastIndexByKey.get(column.keys.join(',')) === index,
    );
  }

  private translateKey(key: string): string {
    switch (key.toLowerCase()) {
      case EQuickSortKey.ACCOUNT:
        return EQuickSortTranslatedKey.ACCOUNT;
      case EQuickSortKey.SITE:
        return EQuickSortTranslatedKey.SITE;
      case EQuickSortKey.ID:
        return EQuickSortTranslatedKey.ID;
      case EQuickSortKey.FLAG:
        return EQuickSortTranslatedKey.FLAG;
      case EQuickSortKey.CREATED_BY:
        return EQuickSortTranslatedKey.CREATED_BY;
      case EQuickSortKey.CREATED:
        return EQuickSortTranslatedKey.CREATED;
      case EQuickSortKey.UPDATED:
        return EQuickSortTranslatedKey.UPDATED;
      default:
        return key.toLowerCase();
    }
  }
}
